import React from 'react';  
import { Route, Switch } from 'react-router-dom';
import App from './components/App/App';
import CreateComplaint from './containers/CreateComplaint';
import SearchComplaint from './components/SearchComplaint/SearchComplaint';
import ComplaintOverView from './containers/ComplaintOverview';
import StartPage from './components/StartPage/StartPage';
import NotFoundPage from './pages/not-found';

export const CREATE_COMPLAINT = "/CreateComplaint";
export const CREATE_COMPLAINT_CUSTOMER = "/Customer";
export const CREATE_COMPLAINT_POSITIONS = "/Positions";
export const INDEX = "/";
export const PREVIEW_COMPLAINT = "/PreviewComplaint";
export const SEARCH_COMPLAINT = "/SearchComplaint";

export default (
    <App>
        <Switch>
            <Route path={INDEX} exact component={StartPage}/>
            <Route path={SEARCH_COMPLAINT} component={SearchComplaint}/>
            <Route path={CREATE_COMPLAINT} component={CreateComplaint}/>
            <Route path={PREVIEW_COMPLAINT} component={ComplaintOverView}/>
            <Route component={NotFoundPage}/> 
        </Switch>
    </App>
);


// WEBPACK FOOTER //
// ./src/routes.js